<template>
  <v-content>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable :title="title" :headers="headers" :items="invoices" :search="search" />
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import store from "@/store"
import { mapGetters } from "vuex"
import { FETCH_INVOICES } from "@/store/actions.type"
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"

export default {
  name: "Invoices",
  async beforeRouteUpdate(to, from, next) {
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    if(store.state.auth.user.company.account_type !== 'on-demand'){
      store.commit(SET_ROUTER_ENTER, false)
      this.$router.push("/dashboard");
    }
    await store.dispatch(FETCH_INVOICES, "list-invoices").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)

      }
    });
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    next();
  },
  data: function() {
    return {
      title: "Invoices",
      headers: [
        { text: "Invoice Number", value: "number" },
        { text: "Date", value: "date" },
        { text: "Amount", value: "total" },
        { text: "Status", value: "status" },
        { text: "", value: "pdf", sortable: false }
      ],
      search: "",
      singleSelect: ""
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable")
  },
  computed: {
    ...mapGetters(["invoices"])
  }
};
</script>